module.exports = __webpack_public_path__ + "media/x_men.3db761c1.mp3";